// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recaptcha-google-link {
  color: #668138;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/google-privacy-agreement/google-privacy-agreement.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ","sourcesContent":[".recaptcha-google-link {\r\n    color: #668138;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
